var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Label',{class:_vm.classes,attrs:{"text":String(_vm.text),"textWrap":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }